import { MonacoLanguageType } from "@hex/common";
import { Static, String } from "runtypes";
import { EmptyObject } from "type-fest";

import { ContextWorkbenchEntityRef } from "./contextWorkbenchEntity";

type AnyObject = Record<string, unknown>;

export const ContextWorkbenchFileId = String.withBrand(
  "ContextWorkbenchFileId",
);

export type ContextWorkbenchFileId = Static<typeof ContextWorkbenchFileId>;

/** A file in the context workbench. */
export type ContextWorkbenchFile = ContextWorkbenchFile.Entity;

/** A file in the context workbench. */
export namespace ContextWorkbenchFile {
  export type Type = Type.Entity;

  export namespace Type {
    export const Entity = "Entity" as const;
    export type Entity = typeof Type.Entity;
  }

  /**
   * Common properties for any file displayed in the context workbench,
   * independent of its backing data source.
   */
  type _Base<
    TType extends Type,
    TProperties extends AnyObject = EmptyObject,
  > = {
    id: ContextWorkbenchFileId;
    type: TType;
    readonly contents: string | null;
    readonly filepath: string;
    readonly stem: string;
    readonly extension: string;
    readonly language: MonacoLanguageType;
    readonly sizeBytes: number | null;
    readonly readOnly: boolean;
    readonly canDelete: boolean;
  } & TProperties;

  /**
   * A file that points to an entity. The file maintains a stable ID for tab
   * persistence while the underlying entity may be loading or absent.
   */
  export type Entity = _Base<
    "Entity",
    {
      entityRef: ContextWorkbenchEntityRef;
    }
  >;
}
